import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

export interface ChangedGame { id: string; name: string }
export interface GameWarnings { id: string; name: string; messages: string[] }

interface Props {
  open: boolean;
  // "Skip": commit pending edits without recomputing the leaderboard.
  onSkip: () => void;
  // "Apply": commit pending edits AND bundle the leaderboard recompute
  // into the same save commit.
  onApply: () => void;
  changedGames: ChangedGame[];
  // Games kept as-is because their classifica was edited by hand.
  skippedManual?: ChangedGame[];
  // Scoring-criteria warnings from the preview (pari merito left in
  // place because the deciding data isn't recorded, unmarked finals, …).
  warnings?: GameWarnings[];
}

export const RecomputeLeaderboardDialog: React.FC<Props> = ({
  open, onSkip, onApply, changedGames, skippedManual = [], warnings = [],
}) => {
  return (
    <Dialog open={open} onClose={onSkip}>
      <DialogTitle>Aggiornare la classifica?</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 1 }}>
          Verranno aggiornati i seguenti giochi:
        </DialogContentText>
        <List dense>
          {changedGames.map((g) => (
            <ListItem key={g.id} disableGutters>
              <ListItemText primary={g.name} />
            </ListItem>
          ))}
        </List>
        {skippedManual.length > 0 && (
          <DialogContentText variant="body2">
            🔒 Non verranno aggiornati perché modificati a mano:{' '}
            {skippedManual.map((g) => g.name).join(', ')}
          </DialogContentText>
        )}
        {warnings.length > 0 && (
          <Alert severity="warning" sx={{ mt: 1 }}>
            <List dense disablePadding>
              {warnings.flatMap((g) =>
                g.messages.map((m, i) => (
                  <ListItem key={`${g.id}-${i}`} disableGutters sx={{ py: 0.25 }}>
                    <ListItemText
                      primary={`${g.name}: ${m}`}
                      primaryTypographyProps={{ variant: 'body2' }}
                    />
                  </ListItem>
                )),
              )}
            </List>
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onSkip}>Salva senza aggiornare</Button>
        <Button onClick={onApply} variant="contained">Salva e aggiorna</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecomputeLeaderboardDialog;
